import { coworkReportRegistryTemplates } from "./report-template-registry.generated"

const coworkReportTemplatePresentation = [
  {
    id: "trial-balance",
    group: "estonia",
    formatKey: "cowork.agent.settings.templates.format.xlsx",
    titleKey: "cowork.agent.settings.template.trialBalance.title",
    descriptionKey: "cowork.agent.settings.template.trialBalance.description",
    visiblePromptKey: "cowork.agent.settings.template.trialBalance.visiblePrompt",
  },
  {
    id: "journal",
    group: "estonia",
    formatKey: "cowork.agent.settings.templates.format.xlsx",
    titleKey: "cowork.agent.settings.template.journal.title",
    descriptionKey: "cowork.agent.settings.template.journal.description",
    visiblePromptKey: "cowork.agent.settings.template.journal.visiblePrompt",
  },
  {
    id: "account-card",
    group: "estonia",
    formatKey: "cowork.agent.settings.templates.format.xlsx",
    titleKey: "cowork.agent.settings.template.accountCard.title",
    descriptionKey: "cowork.agent.settings.template.accountCard.description",
    visiblePromptKey: "cowork.agent.settings.template.accountCard.visiblePrompt",
  },
  {
    id: "pnl",
    group: "core",
    formatKey: "cowork.agent.settings.templates.format.analysis",
    titleKey: "cowork.agent.settings.template.pnl.title",
    descriptionKey: "cowork.agent.settings.template.pnl.description",
    visiblePromptKey: "cowork.agent.settings.template.pnl.visiblePrompt",
  },
  {
    id: "balance-sheet",
    group: "core",
    formatKey: "cowork.agent.settings.templates.format.analysis",
    titleKey: "cowork.agent.settings.template.balanceSheet.title",
    descriptionKey: "cowork.agent.settings.template.balanceSheet.description",
    visiblePromptKey: "cowork.agent.settings.template.balanceSheet.visiblePrompt",
  },
  {
    id: "management-report",
    group: "core",
    formatKey: "cowork.agent.settings.templates.format.dashboard",
    titleKey: "cowork.agent.settings.template.management.title",
    descriptionKey: "cowork.agent.settings.template.management.description",
    visiblePromptKey: "cowork.agent.settings.template.management.visiblePrompt",
  },
  {
    id: "cash-bank",
    group: "core",
    formatKey: "cowork.agent.settings.templates.format.analysis",
    titleKey: "cowork.agent.settings.template.cashBank.title",
    descriptionKey: "cowork.agent.settings.template.cashBank.description",
    visiblePromptKey: "cowork.agent.settings.template.cashBank.visiblePrompt",
  },
  {
    id: "ar-ap-aging",
    group: "core",
    formatKey: "cowork.agent.settings.templates.format.analysis",
    titleKey: "cowork.agent.settings.template.arAp.title",
    descriptionKey: "cowork.agent.settings.template.arAp.description",
    visiblePromptKey: "cowork.agent.settings.template.arAp.visiblePrompt",
  },
  {
    id: "estonia-bilanss",
    group: "estonia",
    formatKey: "cowork.agent.settings.templates.format.estonia",
    titleKey: "cowork.agent.settings.template.bilanss.title",
    descriptionKey: "cowork.agent.settings.template.bilanss.description",
    visiblePromptKey: "cowork.agent.settings.template.bilanss.visiblePrompt",
  },
  {
    id: "estonia-kasumiaruanne",
    group: "estonia",
    formatKey: "cowork.agent.settings.templates.format.estonia",
    titleKey: "cowork.agent.settings.template.kasumiaruanne.title",
    descriptionKey: "cowork.agent.settings.template.kasumiaruanne.description",
    visiblePromptKey: "cowork.agent.settings.template.kasumiaruanne.visiblePrompt",
  },
  {
    id: "estonia-kmd",
    group: "estonia",
    formatKey: "cowork.agent.settings.templates.format.estonia",
    titleKey: "cowork.agent.settings.template.kmd.title",
    descriptionKey: "cowork.agent.settings.template.kmd.description",
    visiblePromptKey: "cowork.agent.settings.template.kmd.visiblePrompt",
  },
  {
    id: "estonia-tsd",
    group: "estonia",
    formatKey: "cowork.agent.settings.templates.format.estonia",
    titleKey: "cowork.agent.settings.template.tsd.title",
    descriptionKey: "cowork.agent.settings.template.tsd.description",
    visiblePromptKey: "cowork.agent.settings.template.tsd.visiblePrompt",
  },
] as const

const reportRegistryByID = new Map(coworkReportRegistryTemplates.map((template) => [template.id, template] as const))

export const coworkAccountingReportTemplates = coworkReportTemplatePresentation.map((presentation) => {
  const registered = reportRegistryByID.get(presentation.id)
  if (!registered) throw new Error(`Missing generated report registry entry: ${presentation.id}`)
  return {
    ...presentation,
    version: registered.version,
    domain: registered.domain,
    country: registered.jurisdiction,
    category: registered.domain,
    reportType: registered.reportType,
    availability: registered.availability,
    validationMaturity: registered.validationMaturity,
    definition: registered.definition,
    requiredSkills: registered.requiredSkills,
  }
})

export type AccountCardSelection = { account_code: string; include_subaccounts: boolean }

export function validAccountCardSelection(value: unknown): value is AccountCardSelection {
  if (!value || typeof value !== "object") return false
  const selection = value as AccountCardSelection
  return typeof selection.account_code === "string" && !!selection.account_code.trim() &&
    selection.account_code.trim().length <= 100 && !/\s/.test(selection.account_code.trim()) &&
    typeof selection.include_subaccounts === "boolean"
}

export function filterCoworkReportTemplates(filters: { country?: string; category?: string }) {
  return coworkAccountingReportTemplates.filter(
    (template) =>
      template.availability === "enabled" &&
      (!filters.country || template.country === filters.country) &&
      (!filters.category || template.category === filters.category),
  )
}
